import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  `;
interface CircleProps {
  $isHighlighted: boolean;
}

export const Circle = styled.div<CircleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 32px;
  height: 32px;

  overflow: hidden;
  border-radius: 50%;
  background-color: transparent;

  border: 1px solid ${BRAND_COLORS.darkStroke};

  ${TYPOGRAPHY.CIRCULAR.bold}
  color: ${BRAND_COLORS.darkStroke};
  font-size: 14px;
  line-height: 24px;
  text-align: center;

  ${({ $isHighlighted }) => $isHighlighted && css`
    color: ${BRAND_COLORS.white};
    background-color: ${BRAND_COLORS.blue};
    border-color: ${BRAND_COLORS.blue};
  `}

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      width: 24px;
      height: 24px;

      font-size: 12px;
      line-height: 22px;
    `,
  )}
`;

interface TextProps {
  $isHighlighted: boolean;
}

export const Text = styled.div<TextProps>`
  ${TYPOGRAPHY.CIRCULAR.bold}
  color: ${BRAND_COLORS.darkStroke};
  text-align: center;
  font-size: 14px;
  line-height: normal;
  white-space: nowrap;

  ${({ $isHighlighted }) => $isHighlighted && css`
    color: ${BRAND_COLORS.blue};
  `}

  ${applyStylesForScreenSize(
    [SCREEN_SIZES.PHONE],
    css`
      font-size: 12px;
    `,
  )}
`;
